import { Color } from '@/constants/color';
import Button from '@/ui/components/Button';

interface Props {
  selectedCount: number;
  onSendMessage: () => void;
  onClear: () => void;
}

const BulkActionBar = ({ selectedCount, onSendMessage, onClear }: Props) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-20 flex items-center gap-4 rounded-lg bg-gray-900 px-6 py-3 shadow-lg text-white">
      <span className="text-sm font-medium">{selectedCount} selected</span>
      <Button color={Color.BLUE} size="sm" onClick={onSendMessage}>
        Send Message
      </Button>
      <button
        type="button"
        onClick={onClear}
        className="text-sm text-gray-300 hover:text-white underline">
        Clear
      </button>
    </div>
  );
};

export default BulkActionBar;
